import { useCallback } from 'react';
import type { TradePerspective } from '~/graphql/graphql';
import { enqueueKeyedWrite, resetKeyedWriteQueues } from '~/utils/writeQueue';

export type PreferenceWriteQueue = <T>(run: () => Promise<T>) => Promise<T>;

export function preferenceSlot(
  view:
    | 'inventory'
    | 'orders'
    | 'comparison'
    | 'buyLists'
    | 'myBuyLists'
    | 'pricing'
    | 'requestsForQuote',
  perspective: TradePerspective
): string {
  return `${view}:${perspective}`;
}

export function enqueuePreferenceWrite<T>(
  slot: string,
  run: () => Promise<T>
): Promise<T> {
  return enqueueKeyedWrite(`preference:${slot}`, run);
}

export function resetPreferenceWriteQueues(): void {
  resetKeyedWriteQueues();
}

export function usePreferenceWriteQueue(slot: string): PreferenceWriteQueue {
  return useCallback(
    <T>(run: () => Promise<T>): Promise<T> => enqueuePreferenceWrite(slot, run),
    [slot]
  );
}
